import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
export default function Signup() {
  const { signUp } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)
  async function handleSubmit(e) {
    e.preventDefault(); setError('')
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return }
    setLoading(true)
    const err = await signUp(email, password)
    if (err) setError(err.message); else setSuccess(true)
    setLoading(false)
  }
  if (success) return (
    <div className="auth-page"><div className="auth-bg" />
      <div className="auth-card" style={{textAlign:'center'}}>
        <div className="auth-logo">CHECK EMAIL</div>
        <p className="auth-subtitle" style={{marginTop:12}}>Confirmation sent to <strong style={{color:'var(--text)'}}>{email}</strong></p>
        <p className="auth-switch" style={{marginTop:20}}><span onClick={()=>window.location.href='/login'}>Back to sign in →</span></p>
      </div>
    </div>
  )
  return (
    <div className="auth-page"><div className="auth-bg" />
      <div className="auth-card">
        <div className="auth-logo">DRAGONCLAW<span>CREATE ACCOUNT</span></div>
        <p className="auth-subtitle">Start free — upgrade anytime</p>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="field"><label>Email</label><input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" required /></div>
          <div className="field"><label>Password</label><input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Min. 8 characters" required /></div>
          <button className="btn-fire" type="submit" disabled={loading}>{loading?'CREATING…':'CREATE ACCOUNT'}</button>
        </form>
        <p className="auth-switch">Have an account? <span onClick={()=>window.location.href='/login'}>Sign in</span></p>
      </div>
    </div>
  )
}
